import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { localizeCategory } from "../utils/mapWooProduct";

export function useLocalizedCategories(categories = []) {
  const { i18n } = useTranslation();

  return useMemo(
    () => categories.map((category) => localizeCategory(category, i18n.language)),
    [categories, i18n.language],
  );
}
